module.exports = {"150302001":"凤凰岭街道","150302002":"海北街道","150302003":"新华街道","150302004":"新华西街道","150302007":"滨河街道","150302008":"林荫街道","150302101":"千里山镇","150302400":"乌海市海勃湾千里山工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150302.json
// module id = 500
// module chunks = 0